var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'join-list',
  created () {
    this.search(false)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  data () {
    return {
      joinClass: '',
      searchCallbackFlag: false
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  computed: {
    joins () {
      return this.$store.getters.joinList
    },
    nextPage () {
      return this.$store.getters.joinListNextPage
    },
    loading () {
      return this.$store.getters.apiLoading
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function(readMore) {
      var url = null
      if (readMore) {
        url = this.$store.getters.joinListNextPage
      } else {
        this.searchCallbackFlag = false
      }
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
      }
      var data = {'join_class': this.joinClass}
      this.$store.dispatch('JOIN_LIST_SEARCH', {url: url, data:data, callback: callback})
    },
    goJoinNew: function () {
      this.$router.push({ path: '/joins/new', query: { type: this.$router.currentRoute.query.type}})
    },
    goJoinEdit: function(joinId) {
      this.$router.push({ path: '/joins/' + joinId + '/edit'})
    },
    joinDelete: function(joinId) {
      if (window.confirm(this.$t('Delete Confirm'))) {
        this.$store.dispatch('JOIN_DELETE',  {id: joinId, callback: this.onSaved})
      }
    },
    half: function () {
      this.joinClass = utils.emHalf(this.joinClass)
    },
    onSaved: function (result) {
      this.$router.push('/joins')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/join-list.js